import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface PurchaseCommunityTransactionItem {
    readonly availableForNotVatPayer: boolean;
    readonly default: boolean;
    readonly defaultVatRateId?: number;
    readonly id: number;
    readonly name: string;
    readonly reverseCharge: boolean;
    readonly symbol: PurchaseCommunityTransactionSymbol;
}

interface PurchaseCommunityTransactionInternalItem {
    readonly availableForNotVatPayer: boolean;
    readonly default: boolean;
    readonly defaultVatRateId?: number;
    readonly id: number;
    readonly name: string;
    readonly reverseCharge: boolean;
    readonly symbol: PurchaseCommunityTransactionSymbol;
    readonly translationKey: string;
}

export type PurchaseCommunityTransactionSymbol = 'ZK' | 'WNT' | 'IT' | 'IU' | 'OO';

export class CommunityTransactionForPurchaseQuery extends Query<PurchaseCommunityTransactionItem[]> { }

export class CommunityTransactionForPurchaseQueryHandlerBase implements QueryHandler<CommunityTransactionForPurchaseQuery, PurchaseCommunityTransactionItem[]> {
    private static Url = TaggedUrl.join('purchase/communityTransactions', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: CommunityTransactionForPurchaseQuery): Promise<PurchaseCommunityTransactionItem[]> {
        const { data: { items } } = await this.http.get<{ items: PurchaseCommunityTransactionInternalItem[] }>(CommunityTransactionForPurchaseQueryHandlerBase.Url);
        return items.map(item => ({
            id: item.id,
            availableForNotVatPayer: item.availableForNotVatPayer,
            default: item.default,
            defaultVatRateId: item.defaultVatRateId,
            name: item.name,
            reverseCharge: item.reverseCharge,
            symbol: item.symbol
        }));
    }
}
